import type { ELeadStage, ILead } from 'src/services/api/leads/types';
import type { IMessage } from 'src/services/api/messages/types';
import {type IShowing} from 'src/api/landlord-showings-api';


export enum EActionSuggestionAction {
    OPEN_SNIPPETS = 'OPEN_SNIPPETS',
    CHANGE_SPECIFIC_STAGE = 'CHANGE_SPECIFIC_STAGE',
    OPEN_TOUR_MODAL = 'OPEN_TOUR_MODAL',
}

export enum EActionSuggestionType {
    default = 'default',
    warning = 'warning',
}

export interface IActionSuggestion {
    title: string;
    description: string;
    type: EActionSuggestionType;
    changeToSpecificStage?: ELeadStage;
    tourStatusAction?: { tourId: number };
    hideScheduleTour?: boolean;
}

export const DEFAULT_LEAD_NAME = 'this lead' as const;


export type FinderCriteriaFn = (lead: ILead, messages: IMessage[], showings: IShowing[]) => IActionSuggestion;
